import * as _ from 'lodash';

export const FormMixin = {

    data() {
        return {
            formCopy: {}
        }

    },
    computed: {
        formValid() {
            return Object.keys(this.fields).every(field => this.fields[field]  && this.fields[field].valid);
        },
        formPristine() {
            return _.isEqual(this.form, this.formCopy);
        },
        formValidated() {
            return Object.keys(this.fields).some(field => this.fields[field]  && this.fields[field].validated);
        },
        isDirty() {
            return !_.isEqual(this.form, this.formCopy);
        }
    },
    beforeMount() {
        this.formCopy = _.cloneDeep(this.form);
    }
};


// WEBPACK FOOTER //
// ./src/mixins/FormMixin.js